// extracted by mini-css-extract-plugin
export default {"link":"HC-z","disabled":"IC-z"};